import { grey } from "@faro-lotv/flat-ui";
import { Divider } from "@mui/material";
import { Stack } from "@mui/system";
import { AriaAttributes, PropsWithChildren, type JSX } from "react";
import { ViewOptionSwitch } from "./view-options-switch";

type ViewOptionSectionProps = PropsWithChildren<{
  /** The label of the switch */
  label: string;
  /** True if the option is enabled */
  isChecked: boolean;
  /** Callback executed when the user toggles the value */
  onToggled(visible: boolean): void;
}> &
  Pick<AriaAttributes, "aria-label">;

/** @returns A switch wrapping a whole section for the view options menu */
export function ViewOptionSection({
  label,
  isChecked,
  onToggled,
  children,
  ...rest
}: ViewOptionSectionProps): JSX.Element {
  return (
    <Stack sx={{ gap: "4px" }} {...rest}>
      <ViewOptionSwitch
        label={label}
        variant="heading14"
        isChecked={isChecked}
        onToggled={onToggled}
      />
      {children}
      <Divider sx={{ borderColor: grey[800] }} />
    </Stack>
  );
}
